import React from "react";
import {
  Modal,
  Descriptions,
  Divider,
  Typography,
  Row,
  Col,
  Tag,
  Tooltip,
  Card,
  Button,
} from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const getStatusBadge = (status) => {
  const label = status === 1 || status === "Active" ? "Active" : "Suspended";
  const color = label === "Active" ? "green" : "red";
  return (
    <Tag color={color} style={{ borderRadius: 12, fontWeight: 500 }}>
      {label}
    </Tag>
  );
};

const getKycBadge = (kyc) => {
  const label =
    kyc === "PENDING"
      ? "Pending"
      : kyc === "APPROVED"
      ? "Approved"
      : kyc === "REJECTED"
      ? "Rejected"
      : "Under Review";
  const color =
    label === "Approved"
      ? "green"
      : label === "Pending"
      ? "gold"
      : label === "Rejected"
      ? "red"
      : "default";
  return (
    <Tag color={color} style={{ borderRadius: 12, fontWeight: 500 }}>
      {label}
    </Tag>
  );
};

const getWalletActiveBadge = (wallet) => {

  const isActive = wallet?.walletActive === true;
  const color = isActive ? "green" : "red";
  const text = isActive ? "Active" : "Frozen";
  const icon = isActive ? <CheckCircleOutlined /> : <CloseCircleOutlined />;

  return (
    <Tooltip title={`Wallet is ${text}`}>
      <Tag
        color={color}
        icon={icon}
        style={{ borderRadius: 12, fontWeight: 500 }}
      >
        {text}
      </Tag>
    </Tooltip>
  );
};

export default function UserWalletDetailsModal({ visible, onClose, user }) {
  console.log("selectedUser", user);
  return (
    <Modal
      title="User & Wallet Details"
      open={visible}
      onCancel={onClose}
      footer={<Button onClick={onClose}>Close</Button>}
      width={1000}
      bodyStyle={{
        padding: "16px 20px",
        maxHeight: "80vh",
        overflowY: "auto",
      }}
      centered
      destroyOnClose
    >
      {user ? (
        <Row gutter={[24, 24]}>
          {/* Left side */}
          <Col xs={24} md={14}>
            <Title level={4} style={{ marginBottom: 16 }}>
              Personal Information
            </Title>
            <Descriptions
              bordered
              column={1}
              size="middle"
              labelStyle={{
                fontWeight: "600",
                minWidth: 140,
                whiteSpace: "nowrap",
              }}
              contentStyle={{ fontWeight: 500 }}
            >
              <Descriptions.Item label="Name">
                {user.name || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="User Code / ID">
                {user.userCode || user.id}
              </Descriptions.Item>
              <Descriptions.Item label="Email">
                {user.email || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Mobile Number">
                {user.mobileNo || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Date of Birth">
                {user.dob ? user.dob.slice(0, 10) : "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Gender">
                {user.gender || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Nationality">
                {user.nationality || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Referral Code">
                {user.refferalCode || "N/A"}
              </Descriptions.Item>
            </Descriptions>

            <Divider style={{ margin: "24px 0" }} />

            <Title level={4} style={{ marginBottom: 16 }}>
              Account Information
            </Title>
            <Descriptions
              bordered
              column={1}
              size="middle"
              labelStyle={{
                fontWeight: "600",
                minWidth: 140,
                whiteSpace: "nowrap",
              }}
              contentStyle={{
                fontWeight: 500,
                fontFamily: "monospace",
                letterSpacing: 0.5,
              }}
            >
              <Descriptions.Item label="Account Number">
                {user.accountNumber || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="User Status">
                {getStatusBadge(user.userStatus)}
              </Descriptions.Item>
              <Descriptions.Item label="KYC Status">
                {getKycBadge(user.kycStatus)}
              </Descriptions.Item>
              <Descriptions.Item label="Welcome Bonus Claimed">
                {user.welcomeBonusClaimed ? "Yes" : "No"}
              </Descriptions.Item>
              <Descriptions.Item label="User Type">
                {user.userType || "N/A"}
              </Descriptions.Item>
            </Descriptions>

            <Divider style={{ margin: "24px 0" }} />

            <Row gutter={[12, 12]}>
              <Col>
                <Text strong>Joined On: </Text>
                <Text>
                  {user.createdDate ? user.createdDate.slice(0, 10) : "N/A"}
                </Text>
              </Col>
              <Col>
                <Text strong>Last Updated: </Text>
                <Text>
                  {user.updatedDate ? user.updatedDate.slice(0, 10) : "N/A"}
                </Text>
              </Col>
            </Row>
          </Col>

          {/* Right side */}
          <Col xs={24} md={10}>
            <Card
              title="Wallet Information"
              bordered
              headStyle={{ fontWeight: "600", fontSize: 18 }}
              bodyStyle={{ padding: "16px" }}
            >
              <Descriptions
                bordered
                column={1}
                size="middle"
                labelStyle={{
                  fontWeight: "600",
                  minWidth: 140,
                  whiteSpace: "nowrap",
                }}
                contentStyle={{
                  fontWeight: 600,
                  fontSize: 16,
                  overflowWrap: "anywhere",
                }}
              >
                <Descriptions.Item label="Balance">
                  $
                  {Number(user.wallet?.totalBalance || 0).toLocaleString(
                    undefined,
                    { minimumFractionDigits: 2 }
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Wallet Status">
                  {getWalletActiveBadge(user.wallet)}
                </Descriptions.Item>
                <Descriptions.Item label="Wallet Created">
                  {user.wallet?.createdDate
                    ? user.wallet.createdDate.slice(0, 10)
                    : "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Wallet Updated">
                  {user.wallet?.updatedDate
                    ? user.wallet.updatedDate.slice(0, 10)
                    : "N/A"}
                </Descriptions.Item>
              </Descriptions>
            </Card>
          </Col>
        </Row>
      ) : (
        <Text>No user selected</Text>
      )}
    </Modal>
  );
}
